export const PHONE_DISPLAY = "7099045899";
export const PHONE_TEL = "+917099045899";
export const WHATSAPP_NUMBER = "917099045899";
export const COMPANY_EMAIL = "thefuturemarketingghy@gmail.com";
export const COMPANY_NAME = "The Future Marketing";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const CATALOGUE_URL = `${BACKEND_URL}/api/catalogue.pdf`;

export function imageUrl(path, w) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  const clean = path.startsWith("/api/images/") ? path : `/api/images/${path}`;
  const q = w ? `?w=${w}` : "";
  return `${BACKEND_URL}${clean}${q}`;
}

export function whatsappLink({ product, size, colour } = {}) {
  let text = "Hello The Future Marketing, I'd like a wholesale quote";
  if (product) text += ` for *${product}*`;
  if (size) text += ` (Size: ${size})`;
  if (colour) text += ` (Colour: ${colour})`;
  text += ". Please share pricing and availability.";
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}

export function whatsappCatalogueLink() {
  const text = `Hello! Here is The Future Marketing wholesale product catalogue (PDF): ${CATALOGUE_URL}`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}

export const NAV_CATEGORIES = ["Artificial Grass", "Mats", "Carpets", "Felt", "Car Mat"];
